import { Unset } from '@utils';

export enum FeatureMetric {
  Min = 'Min',
  Max = 'Max',
  Mean = 'Mean',
  Stddev = 'Stddev',
  Count = 'Count',
  NullRatio = 'Null ratio',
  ZerosRatio = 'Zeros ratio',
  Correlation = 'Correlation',
  FeatureAUC = 'Feature AUC',
}

export type FeatureStatistics = Record<FeatureMetric, number | Unset>;
